import {RootState} from "../../../../store";

export const getSchedulerIsLoading = (state: RootState) => state.schedulerReducer.isLoading || false;
